import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutusOverviewComponent } from './aboutus-overview.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


const routes: Routes = [
  {
    path: '',
    component: AboutusOverviewComponent,
    data: {
      title: "About Us Overview",
      breadcrumb: "About Us Overview"
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [],
  exports: [RouterModule]
})
export class AboutusoverviewRoutingModule { }